import React from 'react';

const ResizeContext = React.createContext({});

export const ResizeProvider = ResizeContext.Provider;

export default ResizeContext;
